"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isLeapYear = void 0;
/**
 * czy rok jest przestępny
 *
 * @param {number} year
 * @returns {boolean}
 */
function isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
exports.isLeapYear = isLeapYear;
//# sourceMappingURL=dateIsLeapYear.js.map